import React, { useState, useRef, useEffect } from "react";
import "../css/Ateheader.css";
import Logo from "../Logo/ate.svg";

const Ateheader: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef<HTMLDivElement | null>(null);

  // Outside click close
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (navRef.current && !navRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    }

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <>
      {/* ================= TOPBAR ================= */}
      <div className="topbar">
        <div className="topbar-left">
          {/* PHONE */}
          <div className="top-item">
            <svg viewBox="0 0 24 24" className="top-icon">
              <path
                d="M6.6 10.8C8.1 13.9 10.1 15.9 13.2 17.4L15.6 15C15.9 14.7 16.3 14.6 16.7 14.7C18 15.1 19.4 15.3 20.8 15.3C21.3 15.3 21.7 15.7 21.7 16.2V20.3C21.7 20.8 21.3 21.2 20.8 21.2C10.8 21.2 2.8 13.2 2.8 3.2C2.8 2.7 3.2 2.3 3.7 2.3H7.8C8.3 2.3 8.7 2.7 8.7 3.2C8.7 4.6 8.9 6 9.3 7.3C9.4 7.7 9.3 8.1 9 8.4L6.6 10.8Z"
                fill="currentColor"
              />
            </svg>
            <span>(+91) 9820479734</span>
          </div>

          {/* MAIL */}
          <div className="top-item">
            <svg viewBox="0 0 24 24" className="top-icon">
              <path
                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4ZM4 8L12 13L20 8V6L12 11L4 6V8Z"
                fill="currentColor"
              />
            </svg>
            <span>info@atecargologistic.com</span>
          </div>
        </div>

        {/* SOCIAL RIGHT */}

        <div className="footer-social">
          <a
            href="https://www.facebook.com/atecourier/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-facebook-f"></i>
          </a>
          <a
            href="https://x.com/AteCargo50306 "
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-x-twitter"></i>
          </a>
          <a
            href="https://www.instagram.com/atecourier/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-instagram"></i>
          </a>
          <a
            href="www.linkedin.com/in/vijay-s-sawant-31b1261b6"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a
            href="https://www.youtube.com/@AteCourier"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-youtube"></i>
          </a>
          <a href="https://wa.me/9820479734" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </div>

      {/* ================= MAIN HEADER ================= */}
      <header className="header">
        <div className="logo-section">
          <img src={Logo} alt="logo" />
        </div>

        {/* NAVIGATION */}
        <nav ref={navRef} className={`nav ${menuOpen ? "active" : ""}`}>
          <a href="https://atecourier.com/index.html">Home</a>
          <a href="https://atecourier.com/about.html">About</a>
          <a href="https://atecourier.com/service.html">Services</a>
          {/* <a href="https://atecourier.com/login.html">B2B</a> */}
          {/* <a href="#">B2C</a> */}
          <a href="https://atecourier.com/contact.html">Contact</a>
          <a href="https://softctl.courieraddaa.com/#/auth/login">
            Branch Login
          </a>
          <a href="https://softctl.courieraddaa.com/CourieraddaaTracking/">
            Tracking
          </a>
        </nav>

        {/*HAMBURGER */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {/* Overlay */}
      {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)}></div>
      )}
    </>
  );
};

export default Ateheader;
